import classnames from 'classnames';
import React from 'react';
import styles from './Empty.scss';
import useTranslation from './Translations/useTranslation';
const Empty = ({ className, dataCy, inline = false, message = '', }) => {
    const { t } = useTranslation();
    return (<span className={classnames(className, styles.message, {
        [styles.block]: !inline,
    })} data-cy={dataCy}>
      {message || `${t('There is no data matching your criteria')}.`}
    </span>);
};
export default Empty;
